var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{ref:"headshot",attrs:{"src":"/audio/headshot.mp3","preload":""}}),_c('audio',{ref:"hallelujah",attrs:{"src":"/audio/worms-hallelujah.mp3","preload":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }